import React from "react";
import { FiArrowDown, FiArrowUpRight } from "react-icons/fi";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import { CONTACT_EMAIL, RESUME_FILENAME, RESUME_URL, socialLinks } from "../data/profile";

const Contact = () => (
    <section id="contact" aria-labelledby="contact-title" className="py-10 md:py-14">
        <SectionHeading id="contact-title" index="05" label="Contact" title="Get In" accent="Touch" />

        <Reveal className="mt-8 md:mt-10">
            <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="link-arrow inline-flex max-w-full items-center gap-3 text-[clamp(1.35rem,3.6vw,2.6rem)] font-semibold leading-tight tracking-[-0.02em]"
            >
                <span className="link min-w-0 [overflow-wrap:anywhere]">{CONTACT_EMAIL}</span>
                <FiArrowUpRight className="btn-arrow shrink-0 text-accent-text" aria-hidden="true" />
            </a>
            <ul className="mt-8 flex flex-wrap gap-2.5">
                {socialLinks.map((social) => (
                    <li key={social.name}>
                        <a
                            href={social.href}
                            target={social.external ? "_blank" : undefined}
                            rel={social.external ? "noopener noreferrer" : undefined}
                            className="btn btn-ghost"
                        >
                            <social.icon aria-hidden="true" />
                            <span>{social.display || social.name}</span>
                            {social.external && <FiArrowUpRight className="btn-arrow" aria-hidden="true" />}
                        </a>
                    </li>
                ))}
                <li>
                    <a href={RESUME_URL} download={RESUME_FILENAME} className="btn btn-primary">
                        <span>Download Resume</span>
                        <FiArrowDown className="btn-arrow btn-arrow-down" aria-hidden="true" />
                    </a>
                </li>
            </ul>
        </Reveal>
    </section>
);

export default Contact;
